import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";
import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";

import { LargeText, SmallTitle } from "../../ui-components/texts";

import { useTranslate } from "../../contexts/translate";

// images
import imageCover from "../../media/images/portfolio-images/capable/image-cover.png";
import {
	Column,
	Container,
	ContainerBlock,
} from "../../ui-components/columns/components";
import { FullWidthVideo } from "../../ui-components/videos";
import { TitleWithScrollXImagesSection } from "./components-design";

const Capable = ({ setNextPageHref = () => {}, setNextPageName = () => {} }) => {
	useEffect(() => {
		setNextPageHref("/projects/locomeal");
		setNextPageName("LocoMeal");
		document.title = "Capable - Cutting Edge Digital Creative Studio";
	}, []);

	const { translations } = useTranslate();
	const peoples = [
		{
			fullname: "Andrea Anfuso",
			image: require("../../media/team-images/Andrea Anfuso.jpg").default,
			role: translations === null ? "" : translations.about.peoples[0].role,
			description:
				translations === null ? "" : translations.about.peoples[0].description,
		},
		{
			fullname: "Davide Balzano",
			image: require("../../media/team-images/no-image.png").default,
			role: translations === null ? "" : translations.about.peoples[16].role,
			description:
				translations === null ? "" : translations.about.peoples[16].description,
		},
	];

	return (
		<div className="project-page project-page-papini">
			<CoverPorfolio
				background="#FBE482"
				className="theme-light"
				title="Cap_able"
				text={translations && translations.capable.intro}
				image={imageCover}
			/>

			<DetailsProject
				client={"Capable, LiveMeFive"}
				services={["Coding, Mobile development"]}
				timeframe={"2023 - 2024"}
				introduction={
					<>
						<LargeText>
							{translations && translations.capable.descriptions[0]}
						</LargeText>
						<LargeText>
							{translations && translations.capable.descriptions[1]}
						</LargeText>
					</>
				}
			/>

			<TitleWithScrollXImagesSection
				removeScroll={true}
				className="theme-light"
				color={"#fff"}
				white={false}
				title={translations && translations.capable.sections[0].title}
				text={translations && translations.capable.sections[0].text1}
				
				items={[
					{
						src: require("../../media/images/portfolio-images/capable/gallery/1.png")
							.default,
					},
					{
						src: require("../../media/images/portfolio-images/capable/gallery/2.png")
							.default,
					},
					{
						src: require("../../media/images/portfolio-images/capable/gallery/3.png")
							.default,
					},
					{
						src: require("../../media/images/portfolio-images/capable/gallery/4.png")
							.default,
					},
				]}
			/>

		

			<PeopleOfMasamune peoples={peoples} />
				<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

Capable.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default Capable;
